// Email document scaffolding (doctype, head/CSS, table wrapper) used by the
// webinar-builder HTML coordinator. Kept in its own file so the email-client
// CSS and MSO fallbacks live in one place — touching these requires testing
// across Outlook/Gmail/Apple Mail, so isolating them makes that easier.

// Opening of the email document: doctype, mso preamble, mobile-responsive
// CSS, and the outer wrapper table. Sections are appended AFTER this.
export const EMAIL_DOCUMENT_OPEN = `
<!DOCTYPE html>
<html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <title>Webinar Invitation</title>
  <!--[if gte mso 9]>
  <xml>
    <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
    </o:OfficeDocumentSettings>
  </xml>
  <![endif]-->
  <style type="text/css">
    body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
    table { border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
    img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }
    @media only screen and (max-width: 620px) {
      .email-container { width: 100% !important; max-width: 100% !important; }
      .mobile-full { width: 100% !important; max-width: 100% !important; }
      .mobile-stack { display: block !important; width: 100% !important; max-width: 100% !important; }
      .mobile-pad { padding-left: 20px !important; padding-right: 20px !important; }
      .mobile-center { text-align: center !important; }
      .mobile-no-side-pad { padding-left: 0 !important; padding-right: 0 !important; }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #e8eaf0;">
    <tr>
      <td align="center" style="padding: 20px 0;">
        <table class="email-container" width="650" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; max-width: 650px; width: 100%;">
`

// Closing of the email document: closes the inner sections table, outer
// wrapper table, body, and html. Appended AFTER all section HTML.
export const EMAIL_DOCUMENT_CLOSE = `
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
    `
